import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getPcrIdSelector } from '../../../home/selectors'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { IPcr } from '../../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../../user/selectors'
import { getHospitalNotifySelector } from '../selectors'
import { setAddToTimeLine } from '../store/hospitalNotify.actions'
import { HospitalNotifyConstants } from '../store/hospitalNotify.constants'
import { IHospitalNotifyState } from '../store/hospitalNotify.types'
import { addHospitalNotifyItem } from '../../../timeline/store/timeline.actions'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'
import { handleNemsisCodeError, getUpdatedProcedureStateWithNemsisCode } from '../../../../utilities/nemsisCode.util'

export function* saveHospitalNotify() {
  let hospitalNotifyState: IHospitalNotifyState = yield select(getHospitalNotifySelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  const { nemsisCodeOptions } = yield select(getProcedureStateSelector)

  if (!pcrID) {
    // todo: add to audit log
    return
  }

  try {
    hospitalNotifyState = getUpdatedProcedureStateWithNemsisCode({
      procedureState: hospitalNotifyState,
      actionField: (s) => s.method?.name,
      filter1Field: null,
      filter2Field: null,
      filter3Field: null,
      nemsisCodeOptions,
    })
  } catch (error: unknown) {
    hospitalNotifyState = handleNemsisCodeError(error, hospitalNotifyState)
  }

  const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
  if (pcrDoc.patient?.hospitalNotifyStateList && pcrDoc.patient?.hospitalNotifyStateList.length) {
    const index = pcrDoc.patient?.hospitalNotifyStateList?.findIndex(
      (hospitalNotify) => hospitalNotify.key === hospitalNotifyState.key
    )
    if (index !== -1) {
      pcrDoc.patient.hospitalNotifyStateList[index] = hospitalNotifyState
    } else {
      pcrDoc.patient?.hospitalNotifyStateList.push(hospitalNotifyState)
    }
  } else {
    pcrDoc.patient = { ...pcrDoc.patient, hospitalNotifyStateList: [hospitalNotifyState] }
  }
  try {
    const pcrDocUpdated = { ...pcrDoc, patient: { ...pcrDoc.patient } }
    yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    yield put(setAddToTimeLine(true))
    yield put(addHospitalNotifyItem())
  } catch (e) {
    yield put(throwPcrException(`saveHospitalNotify() error: ${e}`))
  }
}

export function* saveHospitalNotifySaga() {
  yield takeLatest(
    [
      HospitalNotifyConstants.SAVE_HOSPITAL_NOTIFY,
      HospitalNotifyConstants.SET_DATE,
      HospitalNotifyConstants.SET_TIME,
      HospitalNotifyConstants.SET_DATE_TIME,
      HospitalNotifyConstants.SET_ASSESSED_BY,
      HospitalNotifyConstants.SET_ATTEMPTS,
      HospitalNotifyConstants.SET_POTENTIAL_REGISTRY,
      HospitalNotifyConstants.SET_ROLE_PERFORMING,
      HospitalNotifyConstants.SET_ROLE_PERFORMING_PNNV,
      HospitalNotifyConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT,
      HospitalNotifyConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV,
      HospitalNotifyConstants.SET_PTA,
    ],
    performWithMutexHOG,
    saveHospitalNotify
  )
}
